<script setup lang="ts">
import { computed } from 'vue'

import { TabContainer, Tab } from '../shared/tabs'
import ShowMore from '../shared/ShowMore.vue'

import type { TabbedInfoParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = withDefaults(defineProps<{
  tabbedInfo?: TabbedInfoParagraph['tabbedInfo']
  listOrderPosition?: number
}>(), {
  listOrderPosition: 0
})

const filteredTabs = computed(() => props.tabbedInfo?.tabs?.filter(tab => (tab.items?.length ?? 0) > 0) ?? [])
const hasNonEmptyTabs = computed(() => filteredTabs.value.length > 0)
</script>

<template>
  <div v-if="hasNonEmptyTabs"
       class="bx-content bx-tabbed-info bx-typo--tabbed-info">
    <h3>{{ tabbedInfo?.headline }}</h3>
    <TabContainer>
      <Tab v-for="(tab, tabIndex) in filteredTabs"
           :key="tab.title"
           :title="tab.title ?? ''">
        <div :data-tc="`tabbed-info-${tabIndex}`">
          <ShowMore :max-list-items="8"
                    content-mode="list"
                    :controls-id="`tabbed-info-${listOrderPosition}-${tabIndex}`"
                    :content-label="tab.title ?? ''">
            <ul class="bx-tabbed-info__wrapper">
              <li v-for="(item, itemIndex) in tab.items"
                  :key="itemIndex"
                  :data-tc="`tabbed-info-${tabIndex}-item-${itemIndex}`">
                <span>
                  {{ item.key }}
                </span>
                <span>
                  {{ item.value }}
                </span>
              </li>
            </ul>
          </ShowMore>
        </div>
      </Tab>
    </TabContainer>
  </div>
</template>
